import { Reveal } from "./Elements";

export default function PageHeader({ eyebrow, line1, line2, sub }) {
  return (
    <section className="bg-navy pt-24 pb-16 md:pt-32 md:pb-24" data-testid="page-header">
      <div className="wrap">
        <Reveal>
          {eyebrow && (
            <div className="flex items-center gap-3 text-[11px] font-medium uppercase tracking-[0.22em] text-gold">
              <span className="h-px w-8 bg-gold" aria-hidden="true" />
              <span>{eyebrow}</span>
            </div>
          )}
          <h1 className="mt-5 font-serif font-bold tracking-tight text-4xl sm:text-5xl lg:text-6xl leading-[1.08] text-white">
            <span className="block">{line1}</span>
            <span className="block font-normal italic text-gold">{line2}</span>
          </h1>
          {sub && <p className="mt-6 max-w-2xl text-base sm:text-lg text-mist leading-relaxed">{sub}</p>}
        </Reveal>
      </div>
    </section>
  );
}
